module.exports = __webpack_public_path__ + "static/media/admins-smart.f71bae6e.svg";